/* import __COLOCATED_TEMPLATE__ from './status-cell.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import HasFeatureHelper from '../../../helpers/has-feature';

const STATUSES = [
  {
    text: 'active',
    key: 'active',
  },
  {
    text: 'away',
    key: 'away',
  },
  {
    text: 'away-and-reassigning',
    key: 'reassign',
  },
];

export default class StatusCell extends Component {
  @service intercomEventService;
  @service appService;
  @service permissionsService;
  @service intl;
  @service store;
  @service adminAwayService;

  // @ts-ignore
  hasFeatureHelper = HasFeatureHelper.create(this);

  get canUpdateStatus() {
    return this.permissionsService.currentAdminCan('can_teammates__away_mode__change');
  }

  get canReassignConversationsOnAway() {
    if (!this.hasFeatureHelper.compute(['spg-inbox-reassign-conversations-on-away'])) {
      return true;
    }
    return this.permissionsService.currentAdminCan('can_reassign_conversations_on_away');
  }

  get awayStatusReasons() {
    return this.store.findAll('away-status-reason');
  }

  get admin() {
    return this.args.row.teammate;
  }

  get currentStatusKey() {
    if (this.admin.away_mode_enabled) {
      return this.admin.reassign_conversations ? 'reassign' : 'away';
    }
    return 'active';
  }

  get currentStatusReason() {
    return this.admin?.away_status_reason;
  }

  get currentStatusReasonId() {
    return this.admin?.away_status_reason_id;
  }

  get currentStatusText() {
    let currentStatus = STATUSES.find((status) => status.key === this.currentStatusKey);
    return this.intl.t(`table-cells.teammate-list.status-cell.${currentStatus.text}`);
  }

  get currentCustomReason() {
    return this.currentStatusReasonId
      ? this.store.peekRecord('away-status-reason', this.currentStatusReasonId)
      : null;
  }

  @action
  setActive() {
    this.admin.set('away_mode_enabled', false);
    this.admin.set('reassign_conversations', false);
    this.admin.set('away_status_reason', null);
    this.admin.set('away_status_reason_id', null);
    this.save();
  }

  @action
  setAwayWithStatus(status = null, isReassigning = false) {
    if (isReassigning) {
      this.setAwayAndReassigning(status);
    } else {
      this.setAway(status);
    }
  }

  setAway(status = null) {
    this.admin.set('away_mode_enabled', true);
    this.admin.set('reassign_conversations', false);
    if (status) {
      this.admin.set('away_status_reason', status.label);
      this.admin.set('away_status_reason_id', status.id);
    } else {
      this.admin.set('away_status_reason', null);
      this.admin.set('away_status_reason_id', null);
    }
    this.save();
  }

  setAwayAndReassigning(status = null) {
    this.admin.set('away_mode_enabled', true);
    this.admin.set('reassign_conversations', true);
    if (status) {
      this.admin.set('away_status_reason', status.label);
      this.admin.set('away_status_reason_id', status.id);
    } else {
      this.admin.set('away_status_reason', null);
      this.admin.set('away_status_reason_id', null);
    }
    this.save();
  }

  updateCurrentAdminAwayMode() {
    if (this.admin.id === this.appService.app.currentAdmin.id) {
      this.adminAwayService.updateAwayModeStateWithoutSaving(
        this.admin.away_mode_enabled,
        this.admin.reassign_conversations,
        this.admin.away_status_reason_id,
      );
    }
  }

  save() {
    this.intercomEventService.trackAnalyticsEvent({
      action: this.admin.reassign_conversations ? 'enabled' : 'disabled',
      object: 'reassign_conversation_setting',
      context: 'from_teammate_settings',
      models: [this.admin],
    });
    this.updateCurrentAdminAwayMode();
    this.admin.saveOutOfOfficeSettings();
  }
}
